import dynamic from "next/dynamic";
const Navbar = dynamic(() => import("../components/Navbar"), {
  ssr: false,
});
import Footer from "../components/Footer";
import Policy from "../components/policy/Policy";
import Ournumbers from "../components/discover/Ournumbers";
import WhatWeBelieve from "../components/discover/WhatWeBelieve";

discoverItmtb.title = "All about itmtb Technologies";
discoverItmtb.desc = "All about itmtb Technologies";
discoverItmtb.header_img = "https://www.itmtb.com/discover/discover-itmtb-bg.webp";
export default function discoverItmtb() {
  return (
    <div className="flex flex-col">
      <Navbar />
      <Policy />
      <Footer />
    </div>
  );
}
